import { $Qll, $Q } from '../utils/query-selector'
import { stringToHTML } from '../utils/to-html'
import api from '../services/api'

/**
 * Change the collection filter
 */
 async function changeCollectionFilter(e) {
  const url = `/collections/${e.target.value}`;
  /**
   * Change page URL every time the filter changes
   */
  window.history.replaceState({}, null, url);

  const newFilter = await api.shopifySectionByUrl(url, 'collection-products');
  const listOfProducts = $Q('#list-products', stringToHTML(newFilter));
  const listContainer = $Q('.shopify-section.collection');
  listContainer.innerHTML = listOfProducts.outerHTML;
}
/**
 * Filter by collection
 * @returns {Void}
 */
export const filterCollection = () => {
  const filterInput = $Qll('.filter-input__collection')
  if (!filterInput) return
  filterInput.forEach(
    (input) => {
      input.addEventListener(
        'change',
        changeCollectionFilter
      )
    }
  )
}
